import { Link, useSearchParams } from 'react-router';

import { SCREENS } from '~/styles/extended-theme';
import { useIsBelowBreakpoint } from '~/utils/use-is-below-breakpoint';

import { Button } from './ui/button';
import { Icon } from './ui/icon';

export function BackButton({ defaultPath }: { defaultPath: string }) {
  const belowDesktop = useIsBelowBreakpoint(SCREENS.Desktop);
  const [searchParams] = useSearchParams();
  const src = searchParams.get('src');

  return (
    <Button
      asChild
      variant={belowDesktop ? 'outline-inverted' : 'outline'}
      className="absolute left-4 top-10 z-10"
    >
      <Link to={src ?? defaultPath}>
        <Icon name="arrow-left" className="mr-2" />
        Back
      </Link>
    </Button>
  );
}
